import React from 'react'

import 'react-multi-carousel/lib/styles.css'
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

import { PostsList } from './PostsList'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'

function PostsPage() {
    const [searchParams,] = useSearchParams()
    const {t} = useTranslation()

    return (
        <AppLayout>
            <AppTitle append={<Link to={'/app/posts/add'}>
                <button className="amani-primary">{t('add_post')}</button>
            </Link>}>{t('posts')}</AppTitle>
            {searchParams.get('new') ? <div className="alert alert-success">{t('record_added_success')}</div> : null}

            <PostsList />
        </AppLayout>
    )
}

export default PostsPage
